import { render, staticRenderFns } from "./MediaCreate.vue?vue&type=template&id=72b53aae"
import script from "./MediaCreate.vue?vue&type=script&lang=js"
export * from "./MediaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports